import React, { FC, useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import cx from 'classnames';
import getDefaultTopicUrl from 'utils/getDefaultTopicUrl';

import organizedTopic from 'state/selectors/organizedTopic';

import { Link, Button } from 'components/base';
import { ModuleHeader } from 'components/modules';

import { TagReducer } from 'state/reducers/tag';

import Language from 'constants/Language';
import { RouteMap } from 'constants/Routes';

import {
  Tag,
  TagsIndexModule as ITagsIndexModule,
  GlobalState,
  OrganizedTopic,
} from 'types';

interface StoreProps {
  tags: TagReducer['tagsInAlphabeticalIndex'];
  organizedTopic: OrganizedTopic;
}

interface PassedProps {
  module: ITagsIndexModule;
}

type Props = StoreProps & PassedProps;

const TagsIndexModule: FC<Props> = ({ module, tags, organizedTopic }) => {
  const { moduleHeader } = module;
  const headerTitle = moduleHeader.title;
  const headerDescription = moduleHeader.description;
  const letterKeys = Object.keys(tags).sort();
  const [selectedLetter, setSelectedLetter] = useState(letterKeys[0]);
  const renderModuleHeader = headerTitle || headerDescription;

  return (
    <div
      className={cx(
        'TagsIndexModule bg-color-white color-black module-content-padding-x pb6',
        {
          pt6: !renderModuleHeader,
        }
      )}
    >
      {renderModuleHeader && (
        <div className="TagsIndexModule__header">
          <ModuleHeader title={headerTitle} description={headerDescription} />
        </div>
      )}
      <div className="TagsIndexModule__index">
        <div className="TagsIndexModule__letters flex flex-wrap border-bottom-gray-lighter mb3">
          {letterKeys.map((letter) => (
            <Button
              key={letter}
              className="mr1_5 py_75 flex"
              ariaLabel={Language.t('TagsIndex.letterButtonAriaLabel', {
                letter,
              })}
              onClick={() => setSelectedLetter(letter)}
            >
              <span
                className={cx('text-sm', {
                  'color-black': selectedLetter === letter,
                  'color-gray': selectedLetter !== letter,
                })}
              >
                {letter}
              </span>
            </Button>
          ))}
        </div>
        <div className="TagsIndexModule__tags text-left">
          {(get(tags, selectedLetter, []) as Tag[]).map((tag) => (
            <span key={tag.id} className="TagsIndexModule__tag flex mb1">
              <Link
                variant="hover-underline-blue"
                label={tag.title}
                ariaLabel={tag.topic.title}
                to={getDefaultTopicUrl(organizedTopic, tag.topic.slug)}
              />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: GlobalState): StoreProps => ({
  tags: state.tag.tagsInAlphabeticalIndex,
  organizedTopic: organizedTopic(state),
});

export default connect(mapStateToProps)(TagsIndexModule);
